// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueYouTubeEmbed from 'vue-youtube-embed';
import VueFire from 'vuefire';
// import Firebase from 'firebase';

import App from './App';

Vue.use(VueFire);
Vue.use(VueYouTubeEmbed);
// if you don't want install the component globally
// Vue.use(VueYouTubeEmbed, { global: false })

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: '<App/>',
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js